import { render, staticRenderFns } from "./SmsSettings.vue?vue&type=template&id=3a52d438&scoped=true&"
import script from "./SmsSettings.vue?vue&type=script&lang=js&"
export * from "./SmsSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmsSettings.vue?vue&type=style&index=0&id=3a52d438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a52d438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a52d438')) {
      api.createRecord('3a52d438', component.options)
    } else {
      api.reload('3a52d438', component.options)
    }
    module.hot.accept("./SmsSettings.vue?vue&type=template&id=3a52d438&scoped=true&", function () {
      api.rerender('3a52d438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/Sms/SmsSettings.vue"
export default component.exports